import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/avianex': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M453.1 32c39 0 64.8 31.2 57.8 69.8l-56.7 308.5c-7.1 38.5-44.4 69.7-83.3 69.7h-312c-39 0-64.8-31.2-57.7-69.7l56.6-308.6c7.1-38.5 44.4-69.7 83.3-69.7h312zM394.9 379.3l6.3-7.9-94.9-119.4-4.5-7.3c19.8-14.2 33.5-24.3 35.3-25.6 7.9-6.6 6.3-20.8-2.7-31.3-9.2-10.8-23-14.4-30.7-7.9 0 0-14.4 13.6-33.8 32.4l-4.9-4.5-103.1-112.4-8.9 4.8-18.8 28.9 68.8 99.8 20.5 29.6c-12 12.3-23.5 24.4-32.8 34.9l-58-31.1-15.7 15.4 52.4 48.1 40.6 61 17.9-12.7-22.1-64.2c12.5-7.6 27-17.1 41.7-27.1l115.4 110z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/avianex.js
// module id = 720
// module chunks = 0